import Swiper from "swiper/bundle";
import AOS from "aos";
import "alpinejs";
import * as PhotoSwipe from "photoswipe";
import * as PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

new Swiper(".swiper-container", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".nav-next",
    prevEl: ".nav-prev"
  },
  breakpoints: {
    320: {
      slidesPerView: 1.5
    },
    640: {
      slidesPerView: 2
    }
  }
});

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
  initClassName: "aos-init", // class applied after initialization
  animatedClassName: "aos-animate", // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 100, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 400, // values from 0 to 3000, with step 50ms
  easing: "ease", // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: "center-bottom" // defines which position of the element regarding to window should trigger the animation
});

var input = document.getElementsByClassName("auto-size-input");
for (let i = 0; i < input.length; i++) {
  input[i].setAttribute("size", input[i].getAttribute("placeholder").length);
}
// var initPhotoSwipeFromDOM = function(gallerySelector) {
//   var parseThumbnailElements = function(el) {
//     var all = document.querySelectorAll(gallerySelector);
//     var items = [];
//     for (var j = 0; j < all.length; j++) {
//       var el = all[j];
//       var thumbElements = el.parentNode.childNodes;
//       var numNodes = thumbElements.length,
//         figureEl,
//         linkEl,
//         size,
//         item;
//       for (var i = 0; i < numNodes; i++) {
//         figureEl = thumbElements[i];

//         if (figureEl.nodeType !== 1) {
//           continue;
//         }
//         linkEl = figureEl.children[0];
//         size = linkEl.getAttribute("data-size").split("x");
//         item = {
//           src: linkEl.getAttribute("href"),
//           w: parseInt(size[0], 10),
//           h: parseInt(size[1], 10),
//           minZoom: 3
//         };
//         if (figureEl.children.length > 1) {
//           item.title = figureEl.children[1].innerHTML;
//         }
//         if (linkEl.children.length > 0) {
//           item.msrc = linkEl.children[0].getAttribute("src");
//         }

//         item.el = figureEl;
//         items.push(item);
//       }
//     }
//     return items;
//   };
//   var closest = function closest(el, fn) {
//     return el && (fn(el) ? el : closest(el.parentNode, fn));
//   };
//   var onThumbnailsClick = function(e) {
//     e = e || window.event;
//     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
//     var eTarget = e.target || e.srcElement;
//     var clickedListItem = closest(eTarget, function(el) {
//       return el.tagName && el.tagName.toUpperCase() === "FIGURE";
//     });
//     if (!clickedListItem) {
//       return;
//     }
//     var clickedGallery = clickedListItem.parentNode,
//       childNodes = document.querySelectorAll(gallerySelector),
//       numChildNodes = childNodes.length,
//       nodeIndex = 0,
//       index;
//     for (var i = 0; i < numChildNodes; i++) {
//       if (childNodes[i].nodeType !== 1) {
//         continue;
//       }
//       if (childNodes[i] === clickedListItem) {
//         index = nodeIndex;
//         break;
//       }
//       nodeIndex++;
//     }
//     if (index >= 0) {
//       openPhotoSwipe(index, clickedGallery);
//     }
//     return false;
//   };
//   var photoswipeParseHash = function() {
//     var hash = window.location.hash.substring(1),
//       params = {};
//     if (hash.length < 5) {
//       return params;
//     }
//     var vars = hash.split("&");
//     for (var i = 0; i < vars.length; i++) {
//       if (!vars[i]) {
//         continue;
//       }
//       var pair = vars[i].split("=");
//       if (pair.length < 2) {
//         continue;
//       }
//       params[pair[0]] = pair[1];
//     }
//     if (params.gid) {
//       params.gid = parseInt(params.gid, 10);
//     }
//     return params;
//   };

//   var openPhotoSwipe = function(
//     index,
//     galleryElement,
//     disableAnimation,
//     fromURL
//   ) {
//     var pswpElement = document.querySelectorAll(".pswp")[0],
//       gallery,
//       options,
//       items;
//     items = parseThumbnailElements(galleryElement);
//     options = {
//       maxSpreadZoom: 5,
//       galleryUID: galleryElement.getAttribute("data-pswp-uid"),
//       getThumbBoundsFn: function(index) {
//         var thumbnail = items[index].el.getElementsByTagName("img")[0],
//           pageYScroll =
//             window.pageYOffset || document.documentElement.scrollTop,
//           rect = thumbnail.getBoundingClientRect();
//         return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
//       },
//       minZoom: 3
//       // galleryUID: galleryElement.getAttribute("data-pswp-uid"),
//       // bgOpacity: 0.5,
//       // showHideOpacity: false,

//       // getThumbBoundsFn: function(index) {
//       //   // See Options -> getThumbBoundsFn section of documentation for more info
//       //   var thumbnail = items[index].el.getElementsByTagName("img")[0], // find thumbnail
//       //     pageYScroll =
//       //       window.pageYOffset || document.documentElement.scrollTop,
//       //     rect = thumbnail.getBoundingClientRect();
//       //   console.log(rect);
//       //   return {
//       //     x: rect.left + 0.5 * rect.width,
//       //     y: rect.top + pageYScroll + 0.5 * rect.height,
//       //     w: 0
//       //   };
//       // }
//     };
//     if (fromURL) {
//       if (options.galleryPIDs) {
//         for (var j = 0; j < items.length; j++) {
//           if (items[j].pid == index) {
//             options.index = j;
//             break;
//           }
//         }
//       } else {
//         options.index = parseInt(index, 10) - 1;
//       }
//     } else {
//       options.index = parseInt(index, 10);
//     }
//     if (isNaN(options.index)) {
//       return;
//     }
//     if (disableAnimation) {
//       options.showAnimationDuration = 0;
//     }
//     gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
//     return gallery.init();
//   };
//   var galleryElements = document.querySelectorAll(gallerySelector);
//   for (var i = 0, l = galleryElements.length; i < l; i++) {
//     galleryElements[i].setAttribute("data-pswp-uid", i + 1);
//     galleryElements[i].onclick = onThumbnailsClick;
//   }
//   var hashData = photoswipeParseHash();
//   if (hashData.pid && hashData.gid) {
//     openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
//   }
// };
// // execute above function
// initPhotoSwipeFromDOM(".my-gallery");

var initPhotoSwipeFromDOM = function(gallerySelector) {
  var parseThumbnailElements = function() {
    var all = document.querySelectorAll(gallerySelector);
    var items = [];
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      var thumbElements = el.parentNode.childNodes;
      var numNodes = thumbElements.length,
        figureEl,
        linkEl,
        size,
        item;
      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i];

        if (figureEl.nodeType !== 1) {
          continue;
        }
        linkEl = figureEl.children[0];
        size = linkEl.getAttribute("data-size").split("x");
        item = {
          src: linkEl.getAttribute("href"),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
          minZoom: 3
        };
        if (figureEl.children.length > 1) {
          item.title = figureEl.children[1].innerHTML;
        }
        if (linkEl.children.length > 0) {
          item.msrc = linkEl.children[0].getAttribute("src");
        }

        item.el = figureEl;
        items.push(item);
      }
    }
    return items;
  };
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
    var eTarget = e.target || e.srcElement;
    var clickedListItem = closest(eTarget, function(el) {
      return el.tagName && el.tagName.toUpperCase() === "FIGURE";
    });
    if (!clickedListItem) {
      return;
    }
    var clickedGallery = clickedListItem.parentNode,
      childNodes = document.querySelectorAll(gallerySelector),
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;
    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }
      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }
    if (index >= 0) {
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };
  var photoswipeParseHash = function() {
    var hash = window.location.hash.substring(1),
      params = {};
    if (hash.length < 5) {
      return params;
    }
    var vars = hash.split("&");
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split("=");
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }
    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }
    return params;
  };

  var openPhotoSwipe = function(
    index,
    galleryElement,
    disableAnimation,
    fromURL
  ) {
    var pswpElement = document.querySelectorAll(".pswp")[0],
      gallery,
      options,
      items;
    items = parseThumbnailElements(galleryElement);
    options = {
      galleryUID: galleryElement.getAttribute("data-pswp-uid"),
      bgOpacity: 0.5,
      showHideOpacity: false,

      getThumbBoundsFn: function(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = items[index].el.getElementsByTagName("img")[0], // find thumbnail
          pageYScroll =
            window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();
        console.log(rect);
        return {
          x: rect.left + 0.5 * rect.width,
          y: rect.top + pageYScroll + 0.5 * rect.height,
          w: 0
        };
      }
    };
    if (fromURL) {
      if (options.galleryPIDs) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }
    if (isNaN(options.index)) {
      return;
    }
    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    return gallery.init();
  };
  var galleryElements = document.querySelectorAll(gallerySelector);
  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute("data-pswp-uid", i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

// execute above function
initPhotoSwipeFromDOM(".my-gallery figure");
